import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  Modal,
  Cascader as Cascaded,
  Radio,
  Row,
  Select,
  Space,
} from 'antd'
import _ from 'lodash'
import React, { useContext, useEffect, useState } from 'react'
import { ThemeContext } from '../../../../theme/ThemeContext'
import styles from './dentureLedgerPage.module.css'
import { EditableList } from '../../../../compnents/list/EditableList'
import { DateRangeType, DateSelect, getDateRange } from '../../../../compnents/form/DateSelect'
import { WJGColumns } from './column'
import { getDentalLedgerProcessListAsync } from './dentureLedgerSlice'
import { unwrapResult } from '@reduxjs/toolkit'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../../../app/store'
import moment from 'moment'
import { DateTimeFormatSimpleOnlyOne } from '../../../../models/datetime'

interface RelevancyoOutsideProcessingModalProps {
  relevancyChange?: (processItemId?: any) => void
  keyWord?: string
  id?: any
  visible: boolean
  onOk: (num?: number, obj?: string, cardType?: any) => void
  onCancel: () => void
}

export const RelevancyoOutsideProcessingModal = ({
  relevancyChange,
  keyWord,
  id,
  visible,
  onOk,
  onCancel,
}: RelevancyoOutsideProcessingModalProps) => {

  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const [pageLoading, setPageLoading] = useState(false)

  const [timeHead, timeTail] = getDateRange(DateRangeType.ThisMonth)

  const [params, setParams] = useState<any>({
    current: 1,
    size: 10,
    keyWord: keyWord || '',
  })

  const [page, setPage] = useState<any>({
    total: 0,
    items: [],
  })

  useEffect(() => {
    if (!visible) {
      form.resetFields()
      setPage({
        total: 0,
        items: [],
      })
      setParams({
        current: 1,
        size: 10,
      })
    } else {
      form.setFieldsValue({
        keyWord: keyWord || '',
        _dateRange: 3,
        timeHead: timeHead,
        timeTail: timeTail,
      })
    }
  }, [visible])

  useEffect(() => {
    if (visible) {
      getPage()
    }
  }, [params, visible])

  const getPage = () => {
    setPageLoading(true)
    dispatch(getDentalLedgerProcessListAsync({
      ...params,
      keyWord: form.getFieldValue('keyWord') || '',
      timeHead: undefined,
      timeTail: undefined,
      startDate: params?.timeHead ? moment(params?.timeHead).format(DateTimeFormatSimpleOnlyOne) : moment(timeHead).format(DateTimeFormatSimpleOnlyOne),
      endDate: params?.timeTail ? moment(params?.timeTail).format(DateTimeFormatSimpleOnlyOne) : moment(timeTail).format(DateTimeFormatSimpleOnlyOne)
    }))
      .then(unwrapResult)
      .then((res: any) => {
        setPage({
          total: res?.total || 0,
          items: res?.records || [],
        })
      })
      .finally(() => {
        setPageLoading(false)
      })
  }

  return (
    <Modal
      title={'关联外加工'}
      width={1300}
      visible={visible}
      onCancel={() => {
        onCancel()
      }}
      footer={null}
      className={styles.addPatientModal}
      maskClosable={false}
      destroyOnClose
      centered
    >
      <Form
        className={styles.formStyle}
        form={form}
        onFinish={(values: any) => {
          if (values?.timeHead && values?._dateRange != 6) {
            setParams({
              ...params,
              ...values,
              current: 1,
            })
          }
        }}
      >
        <Row style={{ marginBottom: 10 }} justify='space-between'>
          <Space>
            <Form.Item noStyle name='keyWord'>
              <Input
                autoComplete='off'
                maxLength={20}
                placeholder='患者姓名/助记码/手机号/病历号'
                style={{ width: '17rem' }}
                allowClear
                onChange={() => {
                  form.submit()
                }}
              />
            </Form.Item>
            <DateSelect
              allowClear={false}
              style={{ width: '8.5rem' }}
              labelPrefix=''
              namePrefix='time'
              placeholder='时间范围-时间'
              initialValue={DateRangeType.ThisMonth}
              onChange={(e) => {
                form.submit()
              }}
            />
            <Button
              loading={pageLoading}
              type='primary'
              onClick={() => {
                form.submit()
              }}
            >
              查询
            </Button>
          </Space>
        </Row>
      </Form>
      <EditableList
        loading={pageLoading}
        style={{ height: '470px', overflow: 'hidden' }}
        scroll={{ y: 410 }}
        page={{
          current: params.current,
          size: params.size,
          total: page.total,
          items: page.items,
        }}
        columns={WJGColumns(params.size * (params.current - 1), (action, t,) => {
          switch (action) {
            case 'relevancy':
              relevancyChange && relevancyChange(t)
              break
          }
        },)}
        onChangePage={(current, size) =>
          setParams({
            ...params,
            current,
            size: size || 10,
          })
        }
      />
    </Modal >
  )
}
